import React, { Component, Fragment } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

import ru1 from './ru_1.gif';
import ru2 from './ru_2.gif';
import ru3 from './ru_3.gif';

import en1 from './ru_1.gif';
import en2 from './ru_2.gif';
import en3 from './ru_3.gif';

import styles from './HelpDialogContent.css';

class HelpDialogContent extends Component {
    render() {
        const {
            intl: { locale },
        } = this.props;

        return (
            <Fragment>
                <div className={styles.message}>
                    <FormattedMessage id="Help.Drag files" />
                </div>
                <img alt="" src={locale === 'en' ? en1 : ru1} className={styles.image} />
                <div className={styles.message}>
                    <FormattedMessage id="Help.Fill in" />
                </div>
                <img alt="" src={locale === 'en' ? en2 : ru2} className={styles.image} />
                <div className={styles.message}>
                    <FormattedMessage id="Help.Manual" />
                </div>
                <img alt="" src={locale === 'en' ? en3 : ru3} className={styles.image} />
            </Fragment>
        );
    }
}

export default injectIntl(HelpDialogContent);



// WEBPACK FOOTER //
// ./src/Components/HelpDialogContent/HelpDialogContent.js